import {
  Component,
  ViewEncapsulation,
  OnInit,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import { environment } from '../../../../../environments/environment';
import {setCustomThemeId} from 'app/helpers';

const ALLOWED_DOMAINS = ['template'];

@Component({
  selector: 'app-import-theme-bar',
  templateUrl: './import-theme-bar.component.html',
  styleUrls: ['./import-theme-bar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ImportThemeBarComponent implements OnInit {
  @Input() mode;
  @Output() showThemeImport = new EventEmitter<boolean>();
  @Output() changeMode = new EventEmitter();

  show = false;

  constructor() {}

  ngOnInit(): void {
    const domain = this.getDomain();
    this.show =
      null !== this.getThemeId() &&
      (ALLOWED_DOMAINS.includes(domain) ||
        domain.indexOf('template-fake') === 0);
    if (this.show) {
      document.body.style.overflow = 'hidden';
    }
    this.showThemeImport.emit(this.show);
  }

  isCustomDomain(domain: string): boolean {
    return !environment.appUrl.includes(domain);
  }

  getDomain() {
    const isDomainOnly = window.location.hostname.split('.').length === 2;
    if (isDomainOnly) {
      return window.location.hostname;
    }
    const [subdomain, ...domain] = window.location.hostname.split('.');
    return this.isCustomDomain(domain.join('.'))
      ? window.location.hostname
      : subdomain;
  }

  getThemeId() {
    const params = new URLSearchParams(window.location.search);
    return params.get('themeId');
  }

  redirectToImportTheme() {
    setCustomThemeId(this.getThemeId());
    window.location.href = environment.appUrl + '/auth/register';
    return true;
  }
}
